"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GroundType;
(function (GroundType) {
    GroundType["Clinker"] = "Klinker";
    GroundType["EarthSand"] = "Aarde / Zand";
    GroundType["OrnamentalPavementLarge"] = "Sierbestrating / tegels > 50cm";
    GroundType["OrnamentalPavementSmall"] = "Sierbestrating / tegels < 50cm";
    GroundType["GravelWithGravelMats"] = "Grind op grindmatten";
    GroundType["GravelOnRootClothOrSandySoil"] = "Grind op worteldoek of zandbodem";
    GroundType["PavingOnMixedRubbleGranulates"] = "Bestrating op meng- of puingranulaat";
})(GroundType || (GroundType = {}));
exports.default = GroundType;
